module.exports = __webpack_public_path__ + "static/img/7.ab12a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/list/7.png
// module id = SwDE
// module chunks = 1